import runAfterPageLoad from "./runAfterPageLoad";

export function goToItemOnTableRowClick(rowSelector) {
  runAfterPageLoad(() => {
    $(`table tr${rowSelector} td:not(.actions)`).on("click", (event) => {
      window.location = event.target.parentElement.getAttribute("data-click");
    });
  });
}
